"use strict";
exports.__esModule = true;
exports.throwInvalidExpression = exports.isOperator = exports.isIdentifier = exports.notUtil = exports.xorUtil = exports.orUtil = exports.andUtil = void 0;
var types_1 = require("../types");
var andUtil = function (left, right) { return left && right; };
exports.andUtil = andUtil;
var orUtil = function (left, right) { return left || right; };
exports.orUtil = orUtil;
var xorUtil = function (left, right) { return !(left === right); };
exports.xorUtil = xorUtil;
var notUtil = function (identifier) { return !identifier; };
exports.notUtil = notUtil;
var isIdentifier = function (_a) {
    var name = _a.name, value = _a.value;
    return name === types_1.Tokens.IDENTIFIER && typeof value === 'string';
};
exports.isIdentifier = isIdentifier;
var isOperator = function (_a) {
    var name = _a.name, value = _a.value;
    return name === types_1.Tokens.OPERATOR && typeof value === 'string';
};
exports.isOperator = isOperator;
var throwInvalidExpression = function (message) {
    throw new TypeError("Invalid postfix expression: ".concat(message));
};
exports.throwInvalidExpression = throwInvalidExpression;
